import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import * as reserveTimesActions from '../../../redux/reserveTimes/actions';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import Spin from '../../../components/loading';

const deleteRow = props => {
  props.actions.deleteReservationHour(props.reservationHourId).then(() => {
    if (props.failed == false && props.message == null && props.error == false) {
      AlertAndConfirmation({
        title: locales('titles.deletedSuccessfully'),
        text: '',
        type: 'success'
      });
      props.closeModal();
    }
  });
};

const DeleteReserveHourModal = props => {
  const { loading, error, message, failed } = props;

  return (
    <>
      <Modal id="financial-transaction-modal" size="xl" isOpen={props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('titles.deleteReservationHour')}</div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading}>
            <article>
              {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
              {failed && <div className="alert alert-danger">{message}</div>}
              <div className="col-12 p-0">
                <div className="col-12 p-0">{locales('titles.sureToDeleteReservationHour')} ؟</div>
              </div>
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger mx-1" onClick={() => deleteRow(props)}>
            {locales('labels.yes')}
          </button>
          <button className="btn btn-success mx-1" onClick={() => props.closeModal()}>
            {locales('labels.no')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = state => {
  return {
    loading: state.reservationsReducer.deleteReservationHourLoading,
    error: state.reservationsReducer.deleteReservationHourError,
    failed: state.reservationsReducer.deleteReservationHourFailed,
    message: state.reservationsReducer.deleteReservationHourMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      deleteReservationHour: id => dispatch(reserveTimesActions.deleteReservationHour(id))
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteReserveHourModal);
